module.exports = __webpack_public_path__ + "img/gallery05.21c02d9f.png";